module.exports = __webpack_public_path__ + "img/wechat-integrated-life-vertical.2ed6dad6.png";